import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function OrthoLatexLXPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-04.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-01.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-02.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-03.png",
    ],
    productName: "Ortho Latex LX",
    productLogo:
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ortho-latex-lx-logo.png",
    descriptionTitle: "",
    descriptionText:
      "Ortho Latex LX is made with 7 Zone 100% Latex on top of high density Orthobond foam as core providing firm support to body. High performance graphene fabric with GX technology is used. The 7 Zones created by the zonal latex provide optimum support and comfort adjusting to the different pressures exerted by different body parts.",
    category: { title: "Luxury Collection", link: "/luxury-collection/" },
    points: [
      "7 Zone 100% Latex for superior customized support to varied pressure levels exerted by the body",
      "High-density Orthobond foam as core",
      "High-performance Graphene fabric made of Graphene and Charcoal with GX technology",
      "Unique thermal attributes: Homogenous distribution of heat production in cold temperatures, and heat diffusion in hot temperatures",
      "Bacteriostatic impact: Odor-free and hygienic",
      "Provides firm support",
    ],

    featuresText: ["7 Zone Natural Latex Foam", "Eclipse Orthobond Foam"],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-06.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-07.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-08.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-09.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-10.png",
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-11.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/ortho-latex-lx/ORTHO-LATEX-LX-n-05.png",
    price: "₹19,199 - ₹69,849",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",
    relatedProducts: [
      {
        title: "Ortho Visco LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-visco-lx.jpg",
        link: "/luxury-collection/ortho-visco-lx/",
      },
      {
        title: "Ortho Care LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-care-lx.jpg",
        link: "/serene-series/ortho-care-lx/",
      },
      {
        title: "Harmony Ortho",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmonyortho.jpg",
        link: "/harmony-collection/harmony-ortho/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Ortho Latex Mattress at Best Price | Eclipse International"
        description="Buy Ortho latex mattress that is designed with 100% latex of Orthobond foam as Core to provide firm support to the sleeper's body. Free of odors, environmentally safe and breathable"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-ortholatexlx.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
